<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DelBtn',
})
</script>
<template>
  <Button type="link" danger v-bind="$attrs">
    <template #icon>
      <DeleteOutlined />
    </template>
    <slot />
  </Button>
</template>

<script lang="ts" setup name="DelBtn">
import { DeleteOutlined } from '@ant-design/icons-vue'
import { Button } from 'ant-design-vue'
</script>
